<template>
  <md-card>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <h4 class="card-title">Datos del tramo</h4>
        </div>
        <form
          class="md-layout-item"
          id="highwaySection_form"
          @submit.prevent="saveHighwaySection()"
        >
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field :class="validationClass('name')">
                <label for="name">Nombre</label>
                <md-input
                  data-vv-name="name"
                  v-validate="modelValidations.name"
                  v-model="updatedHighwaySection.name"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field :class="validationClass('highwaySectionNumber')">
                <label for="name">Nombre clave</label>
                <md-input
                  data-vv-name="highwaySectionNumber"
                  v-validate="modelValidations.highwaySectionNumber"
                  v-model="updatedHighwaySection.highwaySectionNumber"
                ></md-input>
                <error-indicator :valid="validField('highwaySectionNumber')"></error-indicator>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field :class="validationClass('highway')">
                <label for="highway">Autopista</label>
                <md-select
                  data-vv-name="highway"
                  v-validate="modelValidations.highway"
                  v-model="updatedHighwaySection.highway"
                  name="highwaySection_company"
                >
                  <md-option
                    v-for="highway in highways"
                    :value="highway.id"
                    :key="highway.id"
                  >{{ highway.name }}</md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field :class="validationClass('state')">
                <label for="state">Estado</label>
                <md-select
                  data-vv-name="state"
                  v-validate="modelValidations.state"
                  v-model="updatedHighwaySection.state"
                  name="state"
                >
                  <md-option
                    v-for="state in states"
                    :value="state.id"
                    :key="state.id"
                  >{{ state.name }}</md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field :class="validationClass('highwaySectionAttendant')">
                <label for="highway_section_attendant">Jefe de conservación</label>
                <md-select
                  data-vv-name="highwaySectionAttendant"
                  v-validate="modelValidations.highwaySectionAttendant"
                  v-model="updatedHighwaySection.highwaySectionAttendant"
                  name="highway_section_attendant"
                >
                  <md-option
                    v-for="highwaySectionAttendant in highwaySectionAttendants"
                    :value="highwaySectionAttendant.id"
                    :key="highwaySectionAttendant.id"
                  >{{ highwaySectionAttendant.name }}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field :class="validationClass('camp')">
                <label for="camp">Campamento</label>
                <md-select
                  data-vv-name="camp"
                  v-validate="modelValidations.camp"
                  v-model="updatedHighwaySection.camp"
                  name="camp"
                >
                  <md-option v-for="camp in camps" :value="camp.id" :key="camp.id">{{ camp.name }}</md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-50">
              <md-field :class="validationClass('start')">
                <label>Km de inicio</label>
                <md-input
                  data-vv-name="start"
                  v-validate="modelValidations.start"
                  v-model="updatedHighwaySection.start"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field :class="validationClass('end')">
                <label>Km de término</label>
                <md-input
                  data-vv-name="end"
                  v-validate="modelValidations.end"
                  v-model="updatedHighwaySection.end"
                ></md-input>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-50">
              <md-field :class="validationClass('administrativeChieff')">
                <label>Jefe administrativo</label>
                <md-select
                  data-vv-name="administrativeChieff"
                  v-validate="modelValidations.administrativeChieff"
                  v-model="updatedHighwaySection.administrativeChieff"
                  name="administrativeChieff"
                >
                  <md-option
                    v-for="ac in AdministrativeChieffs"
                    :key="ac.id"
                    :value="ac.id"
                  >{{ ac.name }}</md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-50">
              <md-switch
                v-model="updatedHighwaySection.receive"
              >¿Recibe factura junto con acta entrega?</md-switch>
            </div>
          </div>
        </form>
      </div>
    </md-card-content>
    <md-card-actions>
      <md-button type="submit" form="highwaySection_form" class="md-success">Aceptar</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import { mapState } from "vuex";
import { ImageField } from "@/components";
import catalogService from "@/services/catalog";

const modelValidations = {
  name: {
    required: true,
  },
  highwaySectionNumber: {
    required: true,
  },
  highway: {
    required: true,
  },
  state: {
    required: true,
  },
  municipality: {
    required: true,
  },
  highwaySectionAttendant: {
    required: true,
  },
  camp: {
    required: true,
  },
  start: {
    required: true,
    decimal: 2,
    min: 1,
  },
  end: {
    required: true,
    decimal: 2,
    min: 1,
  },
  administrativeChieff: {
    required: true,
  },
};

export default {
  name: "EditHighwaySection",
  components: { ImageField },
  props: {
    highwaySection: Object,
    title: {
      type: String,
      default: "Editar tramo",
    },
  },
  data() {
    return {
      updatedHighwaySection: {},
      highwaySectionAttendants: [],
      AdministrativeChieffs: [],
      modelValidations,
      defaultHighwaySection: {
        receive: true,
        highwaySectionDelegation: {},
      },
    };
  },
  methods: {
    saveHighwaySection() {
      const payload = {
        original: this.highwaySection,
        updated: this.updatedHighwaySection,
      };

      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit("saved", payload);
        }
      });
    },
  },
  mounted() {
    this.updatedHighwaySection = {
      ...this.defaultHighwaySection,
      ...this.highwaySection,
    };
    this.watchTouched({ updatedHighwaySection: Object.keys(modelValidations) });
  },
  computed: {
    ...mapState("catalogs", {
      highways: (s) => s.highway,
      states: (s) => s["common/states"],
      camps: (s) => s["highway/camp"],
    }),
    collectedErrors() {
      return this.errors.collect();
    },
  },
  watch: {
    "updatedHighwaySection.highway": function (value) {
      let hw = this.highways.find((el) => el.id === value);

      this.$http
        .get(
          `catalogs/customer/customerstaff/${hw.customer}/encargado-de-tramo/`
        )
        .then((response) => {
          this.highwaySectionAttendants = response.data;
        });

      this.$http
        .get(
          `catalogs/customer/customerstaff/${hw.customer}/jefe-administrativo/`
        )
        .then((response) => {
          this.AdministrativeChieffs = response.data;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Catalogs/HighwaySection/Edit.vue